import { render } from "./text-highlight-up.vue?vue&type=template&id=3e32916e&scoped=true"
const script = {}

import "./text-highlight-up.vue?vue&type=style&index=0&id=3e32916e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e32916e"],['__file',"src/views/other/cssfx/components/text-highlight-up.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e32916e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e32916e', __exports__)) {
    console.log('reload')
    api.reload('3e32916e', __exports__)
  }
  
  module.hot.accept("./text-highlight-up.vue?vue&type=template&id=3e32916e&scoped=true", () => {
    console.log('re-render')
    api.rerender('3e32916e', render)
  })

}


export default __exports__